<template>
  <div
    v-loading="loading"
    class="o-bgPreview"
  >
    <div class="o-bgPreview__header">
      {{ bgType==='XFWB' ? '维保' : bgType==='XFJC' ? '检测' : bgType==='XFPG' ? '评估' : '' }}报告查询
    </div>
    <ul
      v-if="bgType==='XFWB'"
      class="o-bgPreview__list"
    >
      <li class="o-bgPreview__item">
        <span class="o-bgPreview__label">企业名称</span>
        <span class="o-bgPreview__content">{{ bgInfo.wtdw }}</span>
      </li>
      <li class="o-bgPreview__item">
        <span class="o-bgPreview__label">项目名称</span>
        <span class="o-bgPreview__content">{{ bgInfo.xmmc }}</span>
      </li>
      <li class="o-bgPreview__item">
        <span class="o-bgPreview__label">项目地址</span>
        <span class="o-bgPreview__content">{{ bgInfo.xmdz }}</span>
      </li>
      <li class="o-bgPreview__item">
        <span class="o-bgPreview__label">维保单位</span>
        <span class="o-bgPreview__content">{{ bgInfo.lrdw }}</span>
      </li>
      <li class="o-bgPreview__item">
        <span class="o-bgPreview__label">项目负责人</span>
        <span class="o-bgPreview__content">{{ bgInfo.xmfzrMc }}</span>
      </li>
      <li class="o-bgPreview__item">
        <span class="o-bgPreview__label">技术负责人</span>
        <span class="o-bgPreview__content">{{ bgInfo.jsfzrMc }}</span>
      </li>
      <li class="o-bgPreview__item">
        <span class="o-bgPreview__label">维保报告</span>
        <span
          class="o-bgPreview__content o-bgPreview__link"
          @click="handlePreview"
        >
          {{ bgInfo.bgbh }}
        </span>
      </li>
      <li class="o-bgPreview__item">
        <span class="o-bgPreview__label">完成日期</span>
        <span class="o-bgPreview__content">{{ bgInfo.bgrqStr }}</span>
      </li>
    </ul>
    <ul
      v-else-if="bgType==='XFJC'"
      class="o-bgPreview__list"
    >
      <li class="o-bgPreview__item">
        <span class="o-bgPreview__label">委托单位</span>
        <span class="o-bgPreview__content">{{ bgInfo.wtdw }}</span>
      </li>
      <li class="o-bgPreview__item">
        <span class="o-bgPreview__label">项目名称</span>
        <span class="o-bgPreview__content">{{ bgInfo.xmmc }}</span>
      </li>
      <li class="o-bgPreview__item">
        <span class="o-bgPreview__label">项目地址</span>
        <span class="o-bgPreview__content">{{ bgInfo.xmdz }}</span>
      </li>
      <li class="o-bgPreview__item">
        <span class="o-bgPreview__label">检测单位</span>
        <span class="o-bgPreview__content">{{ bgInfo.lrdw }}</span>
      </li>
      <li class="o-bgPreview__item">
        <span class="o-bgPreview__label">检测日期</span>
        <span class="o-bgPreview__content">{{ bgInfo.jcrq }}</span>
      </li>
      <li class="o-bgPreview__item">
        <span class="o-bgPreview__label">检测结论</span>
        <span class="o-bgPreview__content">{{ bgInfo.zhpdjlMc }}</span>
      </li>
      <li class="o-bgPreview__item">
        <span class="o-bgPreview__label">检测报告</span>

        <span
          class="o-bgPreview__content o-bgPreview__link"
          @click="handlePreview"
        >
          {{ bgInfo.bgbh }}
        </span>
      </li>
      <li class="o-bgPreview__item">
        <span class="o-bgPreview__label">完成日期</span>
        <span class="o-bgPreview__content">{{ bgInfo.bgrqStr }}</span>
      </li>
    </ul>
    <ul
      v-else-if="bgType==='XFPG'"
      class="o-bgPreview__list"
    >
      <li class="o-bgPreview__item">
        <span class="o-bgPreview__label">委托单位</span>
        <span class="o-bgPreview__content">{{ bgInfo.wtdw }}</span>
      </li>
      <li class="o-bgPreview__item">
        <span class="o-bgPreview__label">项目名称</span>
        <span class="o-bgPreview__content">{{ bgInfo.xmmc }}</span>
      </li>
      <li class="o-bgPreview__item">
        <span class="o-bgPreview__label">项目地址</span>
        <span class="o-bgPreview__content">{{ bgInfo.xmdz }}</span>
      </li>
      <li class="o-bgPreview__item">
        <span class="o-bgPreview__label">评估单位</span>
        <span class="o-bgPreview__content">{{ bgInfo.lrdw }}</span>
      </li>
      <li class="o-bgPreview__item">
        <span class="o-bgPreview__label">评估日期</span>
        <span class="o-bgPreview__content">{{ bgInfo.pgrqfw }}</span>
      </li>
      <li class="o-bgPreview__item">
        <span class="o-bgPreview__label">评估结论</span>
        <span class="o-bgPreview__content">{{ bgInfo.xfaqdj }}</span>
      </li>
      <li class="o-bgPreview__item">
        <span class="o-bgPreview__label">检测报告</span>

        <span
          class="o-bgPreview__content o-bgPreview__link"
          @click="handlePreview"
        >
          {{ bgInfo.bgbh }}
        </span>
      </li>
      <li class="o-bgPreview__item">
        <span class="o-bgPreview__label">完成日期</span>
        <span class="o-bgPreview__content">{{ bgInfo.bgrqStr }}</span>
      </li>
    </ul>
    <div
      v-if="!loading && !bgType"
      class="o-bgPreview__null"
    >
      <img
        src="~images/main/daiban.png"
      >
      <span>暂无报告信息！</span>
    </div>
  </div>
</template>
<script>
export default {
  name: 'ActionInfo',
  data () {
    return {
      loading: true,
      bgType: null,
      xmId: null,
      xflx: null,
      bgId: null,
      bgInfo: {}
    };
  },
  methods: {
    handlePreview () {
      window.open(`${this.$config.ctx.iffApi}/noauth/xffile/${this.bgId}`, '_self');
    //   this.$axios.get(`${this.$config.ctx.iffApi}/noauth/xffile/${this.bgId}`, { responseType: 'blob' })
    //     .then(rsp => {
    //       const blob = new Blob([rsp.data], { type: 'application/pdf' });
    //       const path = URL.createObjectURL(blob);
    //       setTimeout(() => {
    //         window.open(path);
    //       });
    //     })
    //     .catch((err) => {
    //       console.error('下载文件失败！', err);
    //     });
    }
  },
  created () {
    document.getElementById('preloading').style.display = 'none';
    this.xflx = this.$route.params.xflx;
    this.bgType = this.$route.params.xflx;
    this.xmId = this.$route.params.id;
    if (!this.xmId) {
      this.loading = false;
      return;
    }
    this.$axios.get(`${this.$config.ctx.iffApi}/noauth/xmxx/${this.xflx}/${this.xmId}`)
      .then(rsp => {
        // 跳转省平台页面
        if (rsp.data && rsp.data.fldGuidUrl) {
          window.open(rsp.data.fldGuidUrl, '_self');
          return;
        }

        this.bgInfo = rsp.data;
        if (rsp.data.bgUrl) {
          this.bgId = rsp.data.bgUrl;
          console.log(this.bgId);
        }
      })
      .finally(() => {
        this.loading = false;
      });
  }
};
</script>

<style scoped>
#app{
  background: rgb(246,248,252);
}

.o-bgPreview{
  width: calc(100% - 32px);
  max-width: 750px;
  margin: 16px auto;
  border-radius: 6px;
  box-shadow: 0 3px 6px 0px
    rgba(197, 197, 197, 0.16);
  background-color: #fff;
}

.o-bgPreview__header{
  padding: 40px 0;
  border-top-left-radius: 6px;
  border-top-right-radius: 6px;
  font-size: 28px;
  font-weight: 600;
  color: #fff;
  text-align: center;
  background-image: linear-gradient(346deg,
  #f7d0a1 0%,
  #ff7a2f 100%);
}

.o-bgPreview__list{
  padding: 0 12px 24px;
}

.o-bgPreview__link{
  color: #3889ff;
  cursor: pointer;
}

.o-bgPreview__item{
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 0;
  border-bottom: solid 1px #e5e5e5;
  font-size: 14px;
  color: #474646;
}

.o-bgPreview__label{
  color: #8d8e96;
}

.o-bgPreview__null{
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;
  height: 100%;
  padding: 60px 0 40px;
  color: #ddd;

}

.o-bgPreview__null span {
  margin-top: 18px;
  margin-left: 18px;
  font-size: 14px;
}
</style>
